module.exports = __webpack_public_path__ + "assets/item1.7cdf3322.png";